// Which engine runs the phone (docs/ringcentral/SOFTPHONE.md).

import type { EngineHost, PhoneEngine } from './engine.ts';
import { RingCentralEngine } from './rc-engine.ts';
import { SimulatorEngine } from './sim-engine.ts';

export function makeEngine(name: 'simulator' | 'ringcentral', host: EngineHost): PhoneEngine {
  return name === 'simulator' ? new SimulatorEngine(host) : new RingCentralEngine(host);
}
